import { gql } from '@apollo/client';

export const REGISTER_TOOL_VIEW = gql`
  mutation RegisterToolView($toolId: ID!) {
    registerToolView(input: { toolId: $toolId }) {
      tool {
        id
        viewCount
      }
      errors
    }
  }
`;
